import Dispatcher from "events-dispatch";
import { mask } from "../../services/mask";
import { triggerEvent } from "../../services/helpers/trigger-event";

const opened = new Set();

const events = {
  "opened": "popup.events.opened",
  "closed": "popup.events.closed",
  "open": "popup.events.open",
  "close": "popup.events.close",
};

const init = (() => {
  let inited = false;
  return () =>  {
    if (!inited) {
      inited = true;
      document.addEventListener("click", e => {
        if (e.target.closest('.semi-mask')) {
          Modal.closeAll();
        }
      });
    }
  }
})();

class Modal {
  static get events() {
    return events;
  }
  
  constructor(el, config) {
    this.root = el;

    this.config = this._formatConfig(config);
    this.nodes = this._DOMInit(el);

    this._activate();

    this._hide();
  }

  get closeSelector() {
    return "[data-close]";
  }

  get isBlocked() {
    return true;
  }

  get isSingle() {
    return true;
  }

  _formatConfig(config) {
    return Object.assign({
      beforeOpen: () => true,
      beforeClose: () => true,
    },config);
  }

  _DOMInit(el) {
    let close = el.querySelector(this.closeSelector);
    if (close) {
      close.addEventListener("click", () => this.close());
    }

    return {
      element: el,
      close: close
    };
  }

  _activate() {
    this.nodes.element.style.visibility = "visible";
    this.nodes.element.style.opacity = 1;
    this.nodes.element.classList.remove('hidden');
  }

  close(silent) {
    if (this.config.beforeClose()) {
      this._hide();
      this.constructor.onClose(this);

      if (this.tmpToggler) {
        this.tmpToggler.classList.remove('dropdown-shown');
        this.tmpToggler = null;
      }

      if (!silent) {
        triggerEvent(this.root, events.closed);
      }
    }
  }

  open(silent, toggler) {
    if (this.config.beforeOpen()) {
      if (this.isSingle) {
        this.constructor.closeAll("silent");
      }
      this._show();
      this.constructor.onOpen(this);

      if (toggler) {
        this.tmpToggler = toggler;
        this.tmpToggler.classList.add('dropdown-shown');
      }

      if (!silent) {
        triggerEvent(this.root, events.opened);
      }
    }
  }

  _hide() {
    this.nodes.element.style.display = "none";
  }

  _show() {
    this.nodes.element.style.display = "block";
  }
  
  static closeAll(silent) {
    [...opened].forEach(popup => popup.close(silent));
    opened.clear();
  }

  static onOpen(modal) {
    init();
    opened.add(modal);
    if (modal.isBlocked) {
      mask.block();
    } else {
      mask.inactivate();
    }
  }

  static onClose(modal) {
    opened.delete(modal);
    if (opened.size === 0) {
      mask.reset();
    }
  }

  static check(el) {
    if (el && el instanceof HTMLElement) return true;
    return false;
  }

  static get(el, config) {
    if (this.check(el)) return new this(el, config);
  }
}

export default Modal;